import Button from "../../../../../shared/lib/html5-software-library/src/ranj/components/buttons/Button";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class ItemSlotView extends AbstractView {
    
    constructor(target) {
        super(target);
        this._item = null;
        /**@type {Button} */
        this._button = this.createButton(target, this._handleClick.bind(this));
    }

    /**
     * 
     * @param {DisplayObject} item 
     */
    fill(item) {
        this.clear();
        if (item) {
            this._item = item;
            this._target.addChild(item);
        }
    }

    clear() {
        if (this._item) {
            this._target.removeChild(this._item);
            this._item = null;
        }
    }

    get itemId() {
        return this._item ? this._item.itemId : null;
    }

    set enabled(bool) {
        this._button.setEnabled(bool);
    }

    get enabled() {
        return this._button.getEnabled();
    }

    _handleClick() {
        this.dispatchEvent(ItemSlotView.CLICK);
    }

    set selected(bool) {
        this._button.setSelected(bool);
    }

    get selected() {
        return this._button.getSelected();
    }
}

ItemSlotView.CLICK = "BlockSlotView.CLICK";